/** @jsxImportSource @emotion/react */
import React, { createContext } from 'react'

// use this context if your unit test needs common code.  IF IT DOES, do not take any snapshots - just confirm some
// particular expectations that are specific to your app's usage of common code
export const AllowCommonUiInTestContext = createContext(false)

// this is a convenience wrapper to turn on common UI in your test, if you need it for React testing library style tests
// if you use this, don't take snapshots in your test!
export const AllowCommonUiInTest: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => {
  return (
    <AllowCommonUiInTestContext.Provider value={true}>
      {children}
    </AllowCommonUiInTestContext.Provider>
  )
}

export default AllowCommonUiInTestContext
